// Locale Actions
export const Change_Current_Locale = "Change_Current_Locale";